import React from 'react'
import {getSession} from '@orion-js/graphql-client'
import SessionContext from 'App/helpers/auth/SessionContext'
import useOnEvent from 'App/helpers/globalEvents/useOnEvent'
import useState from 'App/hooks/useState'

export default function SessionContextProvider(props) {
  const [session, setSession] = useState(getSession())

  useOnEvent('saveSession', newSession => {
    setSession(newSession)
  })

  return <SessionContext.Provider value={session || {}}>{props.children}</SessionContext.Provider>
}
